var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('span',{staticClass:"toolbar-title"},[_c('span',{staticClass:"toolbar-title-part"},[_vm._v("Bankszámla kalkulátor - ")]),_c('wbr'),_c('span',{staticClass:"toolbar-title-part"},[_vm._v("együttműködve a K&H Bankkal")])])])
}]

export { render, staticRenderFns }